import { z } from 'zod';

export const MAX_BANK_REQUISITES_LENGTH = 4000;

const BankRequisitesFieldSchema = z.string().max(MAX_BANK_REQUISITES_LENGTH);

const UploadedSignatureStorageKeySchema = z.string().regex(/^signatures\/[a-z0-9_-]+\.svg$/);

const DefaultSignatureStorageKeySchema = z.union([
  z.literal('/public/signature.svg'),
  z.literal('/signature.svg'),
]);

export const SignatureSvgPathSchema = z.union([
  UploadedSignatureStorageKeySchema,
  DefaultSignatureStorageKeySchema,
]);

const SignaturePreviewUrlSchema = z
  .string()
  .regex(/^\/api\/sender-profiles\/[^/?#]+\/signature\?v=\d+$/);

export const SettingsResponseSchema = z
  .object({
    settings: z
      .object({
        id: z.literal(1),
        defaultSenderProfileId: z.string().min(1),
        nextInvoiceNumber: z.number().int().min(1),
        notesTemplateEur: z.string(),
        notesTemplateUsd: z.string(),
        notesTemplateRub: z.string(),
        updatedAt: z.number().int().nonnegative(),
      })
      .strict(),
    senderProfile: z
      .object({
        id: z.string().min(1),
        name: z.string().min(1),
        signatureSvgPath: SignatureSvgPathSchema.nullable(),
        signaturePreviewUrl: SignaturePreviewUrlSchema.nullable(),
        bankRequisitesEur: BankRequisitesFieldSchema,
        bankRequisitesUsd: BankRequisitesFieldSchema,
        bankRequisitesRub: BankRequisitesFieldSchema,
        updatedAt: z.number().int().nonnegative(),
      })
      .strict(),
  })
  .strict();

export const UpdateSettingsInputSchema = z
  .object({
    senderName: z.string().trim().min(1),
    nextInvoiceNumber: z.number().int().min(1),
    notesTemplateEur: z.string(),
    notesTemplateUsd: z.string(),
    notesTemplateRub: z.string(),
    bankRequisitesEur: BankRequisitesFieldSchema,
    bankRequisitesUsd: BankRequisitesFieldSchema,
    bankRequisitesRub: BankRequisitesFieldSchema,
  })
  .strict();

export const SignatureUploadResponseSchema = z
  .object({
    senderProfile: z
      .object({
        id: z.string().min(1),
        signatureSvgPath: UploadedSignatureStorageKeySchema,
        signaturePreviewUrl: SignaturePreviewUrlSchema,
        updatedAt: z.number().int().nonnegative(),
      })
      .strict(),
  })
  .strict();

export type SettingsResponse = z.infer<typeof SettingsResponseSchema>;
export type UpdateSettingsInput = z.infer<typeof UpdateSettingsInputSchema>;
export type SignatureUploadResponse = z.infer<typeof SignatureUploadResponseSchema>;
